import { ChartItem } from './chartItem'
import { CompanyInfoCard } from './companyInfo'
import { Money } from './money'

export enum AssetType {
  etf = 'ETF',
  stock = 'STOCK',
  savingPlan = 'SAVING_PLAN',
  fund = 'FUND',
  idxFund = 'IDX_FUND',
}

export enum AssetManagerCode {
  blk = 'BLK',
}

export interface AssetManager {
  code: AssetManagerCode
  name: string
  logo: string
}

export interface MarketInfo {
  id: string
  sessions: Session[]
}

export enum SessionType {
  regular = 'REGULAR',
  pre = 'PRE',
  post = 'POST',
  overnight = 'OVERNIGHT',
  all = 'ALL',
}

export enum SessionStatus {
  open = 'OPEN',
  closed = 'CLOSED',
}

export interface Session {
  id: SessionType
  title: string
  status: SessionStatus
  window: Window
}

export interface Window {
  openingTime: string
  closingTime: string
}

export interface CompanyInfo {
  data: CompanyInfoCard[]
}

export enum KeyDocumentType {
  KIID = 'KIID',
  AR = 'AR',
  SAR = 'SAR',
  PR = 'PR',
  DIST = 'DIST',
}

export interface KeyDocumentItem {
  type: KeyDocumentType
  url: string
}
export interface CompanyOperatingWindow {
  status: 'OPEN' | 'CLOSED'
  name: string
  time: string
}

export interface CompanyInvestmentInfo {
  minInitial: Money
  minSuccessive: Money
  totalExpenseRatio: number
  subscriptionNavFrequency: string
  redemptionNavFrequency: string
  patrimony: Money
  launchDate: string
}

export interface CompanyRisk {
  srri: number
}

export interface AssetsInfo {
  id?: string
  assetManager?: AssetManager
  chart?: ChartItem[]
  companyInfo?: CompanyInfo
  currency?: string
  errorChart?: string | null
  performance?: {
    increaseMoney?: Money
    increasePercentage?: number
    yearToDate?: number
    oneYear?: number
    threeYears?: number
    fiveYears?: number
    volatility?: number
  }
  investmentInfo?: CompanyInvestmentInfo
  isEnabled?: boolean
  isin?: string
  risk?: CompanyRisk
  isLowLiquidity?: boolean
  keyDocuments?: KeyDocumentItem[]
  lastClosed?: Money
  logoUrl?: string
  market?: string
  marketInfo?: MarketInfo | null
  name?: string
  price?: Money
  priceTime?: string
  subtype?: string
  ticker?: string
  type: AssetType
  categorization?: {
    category: string
    benchmark: string
    fundType: string
  }
  operatingData?: {
    cutOffTime?: {
      next: string
      windows: CompanyOperatingWindow[]
    }
  }
}
